<template lang="html">
  <div class="">
    WrapMaterialDetails
  </div>
</template>

<script>
export default {}
</script>

<style lang="sass" scoped>
</style>
